import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59fe37d1")

_pushScopeId("data-v-59fe37d1")
const _hoisted_1 = {
  key: 0,
  class: "page-ques-detail"
}
const _hoisted_2 = { class: "wrapper main-wrap" }
const _hoisted_3 = { class: "p-main clearfix" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_5 = {
  key: 0,
  class: "ana-box"
}
const _hoisted_6 = { class: "ft" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_question_detail_head = _resolveComponent("question-detail-head")
  const _component_single_choice = _resolveComponent("single-choice")
  const _component_multiple_choice = _resolveComponent("multiple-choice")
  const _component_completion = _resolveComponent("completion")
  const _component_q_a = _resolveComponent("q-a")
  const _component_program = _resolveComponent("program")
  const _component_el_button = _resolveComponent("el-button")
  const _component_answer_analysis = _resolveComponent("answer-analysis")
  const _component_commit_history = _resolveComponent("commit-history")
  const _component_answer_page_foot = _resolveComponent("answer-page-foot")
  const _component_program_panel = _resolveComponent("program-panel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.questionContent.questionType !== 5)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_question_detail_head, {
            title: _ctx.title,
            questionTypeName: _ctx.questionTypeNameMap[_ctx.questionContent.questionType - 1]
          }, null, 8, ["title", "questionTypeName"]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", {
                class: 'q-box' + (_ctx.showAnalysis || _ctx.showHistory ? ' show-border' : '')
              }, [
                (_ctx.questionContent.questionType === 1)
                  ? (_openBlock(), _createBlock(_component_single_choice, {
                      key: 0,
                      quesData: _ctx.questionContent,
                      onChange: _ctx.handleAnswerChange
                    }, null, 8, ["quesData", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.questionContent.questionType === 2)
                  ? (_openBlock(), _createBlock(_component_multiple_choice, {
                      key: 1,
                      quesData: _ctx.questionContent,
                      onChange: _ctx.handleAnswerChange
                    }, null, 8, ["quesData", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.questionContent.questionType === 3)
                  ? (_openBlock(), _createBlock(_component_completion, {
                      key: 2,
                      quesData: _ctx.questionContent,
                      onChange: _ctx.handleAnswerChange
                    }, null, 8, ["quesData", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.questionContent.questionType === 4)
                  ? (_openBlock(), _createBlock(_component_q_a, {
                      key: 3,
                      quesData: _ctx.questionContent,
                      onChange: _ctx.handleAnswerChange
                    }, null, 8, ["quesData", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.questionContent.questionType === 5)
                  ? (_openBlock(), _createBlock(_component_program, {
                      key: 4,
                      quesData: _ctx.questionContent,
                      onStartProgram: _ctx.handleStartProgram
                    }, null, 8, ["quesData", "onStartProgram"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-submit",
                  onClick: _ctx.handleAnswerSubmit,
                  disabled: !_ctx.answerContent
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ], 2),
              (_ctx.showAnalysis)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode(_component_answer_analysis, {
                      analysisData: _ctx.analysisData,
                      questionType: _ctx.questionContent.questionType
                    }, null, 8, ["analysisData", "questionType"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showHistory)
                ? (_openBlock(), _createBlock(_component_commit_history, {
                    key: 1,
                    historyData: _ctx.historyList,
                    type: _ctx.questionContent.questionType,
                    onDelete: _ctx.handleDeleteCommitHistory
                  }, null, 8, ["historyData", "type", "onDelete"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_answer_page_foot, {
                  showAnalysis: _ctx.showAnalysis,
                  showHistory: _ctx.showHistory,
                  onViewAnalysis: _ctx.handleViewAnalysis,
                  onViewHistory: _ctx.handleViewHistory,
                  onRandom: _ctx.handleRandomQuestion,
                  onPrev: _ctx.handlePrevQuestion,
                  onNext: _ctx.handleNextQuestion
                }, null, 8, ["showAnalysis", "showHistory", "onViewAnalysis", "onViewHistory", "onRandom", "onPrev", "onNext"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionContent.questionType === 5)
      ? (_openBlock(), _createBlock(_component_program_panel, {
          key: 1,
          isSingQuesMod: true,
          isExam: false,
          quesData: _ctx.questionContent,
          analysisData: _ctx.analysisData,
          historyData: _ctx.historyList,
          showAnalysis: _ctx.showAnalysis,
          showHistory: _ctx.showHistory,
          onViewAnalysis: _ctx.handleViewAnalysis,
          onViewHistory: _ctx.handleViewHistory,
          onRandom: _ctx.handleRandomQuestion,
          onPrev: _ctx.handlePrevQuestion,
          onNext: _ctx.handleNextQuestion,
          onDeleteCommitHistory: _ctx.handleDeleteCommitHistory,
          title: _ctx.title,
          questionTypeName: _ctx.questionTypeNameMap[_ctx.questionContent.questionType - 1],
          onSave: _ctx.handleAnswerChange
        }, null, 8, ["quesData", "analysisData", "historyData", "showAnalysis", "showHistory", "onViewAnalysis", "onViewHistory", "onRandom", "onPrev", "onNext", "onDeleteCommitHistory", "title", "questionTypeName", "onSave"]))
      : _createCommentVNode("", true)
  ], 64))
})